import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import yo from '../locales/yo.json';
import ig from '../locales/ig.json';
import ha from '../locales/ha.json';

const resources = {
  en: { translation: en },
  yo: { translation: yo },
  ig: { translation: ig },
  ha: { translation: ha },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
